/**
 * Core Module
 *
 * Contains singleton services, guards, and interceptors that are
 * instantiated once and shared across the entire application. Nothing from the
 * features/ directory should be imported here.
 */

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { authInterceptor } from './interceptors/auth.interceptor';
import { notFoundInterceptor } from './interceptors/not-found.interceptor';

export function provideCore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideHttpClient(withInterceptors([authInterceptor, notFoundInterceptor])),
  ]);
}
